import { render, staticRenderFns } from "./WADAClassification.vue?vue&type=template&id=e2ea3032&scoped=true&"
import script from "./WADAClassification.vue?vue&type=script&lang=js&"
export * from "./WADAClassification.vue?vue&type=script&lang=js&"
import style0 from "./WADAClassification.vue?vue&type=style&index=0&id=e2ea3032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ea3032",
  null
  
)

export default component.exports